import { residentFromResidenceType } from '@/containers/SubscriptionFormPageNew/Components/Address/residentFromResidenceType'

export const comparatorPayloadGeneration = ({
  providerWorkflow,
  contractId,
  contactId,
  country,
  address,
  energyType,
  prestationType,
  clientType,
  consumption,
  meterPower,
}) => ({
  workflowName: providerWorkflow || 'default',
  contract_id: contractId,
  contact_id: contactId || null,
  country,
  city_id: address.cityId || '',
  city: address.city || '',
  zipcode: address.zipcode || '',
  province: address.province || '',
  street_name: address.streetName || '',
  energy_type: energyType || '',
  client_type: clientType === 'pro' ? 'business' : 'domestic',
  prestation_type: prestationType || 'cdf',
  is_resident: residentFromResidenceType({ residenceType: address.residenceType, clientType }),
  meter_power_elec: meterPower || '',
  italy_consumption_base: consumption.carElec,
  car_gas: consumption.carGas,
  comparator_mode: true,
})
